var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5136_5164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23C17.0751 23 22 17.8513 22 11.5C22 5.14873 17.0751 0 11 0C4.92487 0 0 5.14873 0 11.5C0 17.8513 4.92487 23 11 23Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3158 15.5C21.758 14.2541 22 12.9067 22 11.5C22 10.0933 21.758 8.74582 21.3158 7.5H0.684191C0.242043 8.74582 0 10.0933 0 11.5C0 12.9067 0.242043 14.2541 0.684191 15.5L11 16.5L21.3158 15.5Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23C15.7296 23 19.7616 19.8792 21.3158 15.5H0.684204C2.23843 19.8792 6.2704 23 11 23Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5136_5164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/russia.7f7c731432381151d3d723dbb02c2b5a.svg";
export { ForwardRef as ReactComponent };